export default "__VITE_ASSET__CgtaKEBs__"